module.exports = __webpack_public_path__ + "static/media/illuminate.00934841.jpg";